angular.module('directives.paginationInfo', [])
  .directive('paginationInfo', [
    function () {
      return {
        restrict: 'E',
        scope: {
          pagination: '=',
          prefix: '=',
          suffix: '=',
          noResultsMessage: '=?'
        },
        controller: [
          '$scope',
          function($scope){
            if (!angular.isDefined($scope.noResultsMessage)) {
              $scope.noResultsMessage = 'No results found';
            }
          }
        ],
        template:
          '<span ng-show="pagination">' +
            '<span ng-show="pagination.total === 0 && noResultsMessage">' +
              '{{noResultsMessage}}' +
            '</span>' +
            '<span ng-show="pagination.total > 0">' +
              '<span class="pre-text">Showing results</span>' +
              ' <strong>{{pagination.firstItemNumber()}}</strong>' +
              ' to <strong>{{pagination.lastItemNumber()}}</strong>' +
              ' of <strong>{{pagination.total | number}}</strong>' +
            '</span>' +
          '</span>' +
          '<span ng-show="!pagination">' +
              'No pagination' +
          '</span>'
      };
    }
  ]);
